//-- angular core
import {Component} from '@angular/core';
import {saveAs} from 'file-saver';

//-- primefaces
import {Dialog} from 'primeng/dialog';
import {MessageService} from 'primeng/api';

//-- app
import {I18NService} from './utils/i18n.service';
import {ResponseXBVO} from './base.model';
import {GLOBALS} from '../../app-globals';
import {environment} from 'src/environments/environment';
import {NgForm} from '@angular/forms';
import {DateUtilsBs} from "./utils/dateUtilsBs";
import {NumberUtils} from "./utils/number.utils";
import {Router} from "@angular/router";


@Component({
    selector: 'base-component',
    template: ''
})

/**
 * Babse component.
 */
export class BaseComponent {

    i18n: I18NService;
    messageService: MessageService;
    messages: String;
    dateUtils = DateUtilsBs.INST;
    today = new Date();
    private yesterday: Date;

    /*
     * Contructor.
     */
    constructor() {
        this.logi(" component instance created !");
        this.i18n = GLOBALS.i18n;
        this.messageService = GLOBALS.messageService;
        this.today = new Date();
        this.yesterday = new Date();
        this.yesterday.setDate(this.today.getDate() -1);
    }


    /**
     * Logs.
     */
    logd(aMessage: String) {
        if (!environment.production) {
            console.log("[" + this.constructor.name + "] " + aMessage);
        }
    }

    /**
     * Logs.
     */
    logi(aMessage: String) {
        console.log("[" + this.constructor.name + "] " + aMessage);
    }

    /**
     * Transates
     */
    v(aKey: string): string {
        return this.i18n.v(aKey);
    }

    ve(aType: string, aKey: any) {
        return this.i18n.v(aType + "." + aKey);
    }


    /**
     * Transates
     */
    vp(aKey: string, aParams: string[]): string {
        if (!aParams) {
            return aKey;
        }
        var pResult = this.i18n.v(aKey);
        for (var pParam of aParams) {
            pResult = pResult.replace("%s", pParam);
        }
        return pResult;
    }

    public maximizeDialog(event, dialog: Dialog) {
        if (this.isMobile()) {
            dialog.maximize();
        }
    }

    /**
     * Shows message
     */
    public toastViolation(aMessage: string) {
        this.messageService.clear();
        this.messageService.add({severity: 'error', detail: aMessage, life: 2500, closable: true, sticky: false, key: "toast-messages"});
    }

    /**
     * Shows message
     */
    public toastInfo(aMessage: string, aLife?: number) {
        this.messageService.clear();
        this.messageService.add({severity: 'info', detail: aMessage, life: aLife ? aLife : 1500, closable: false, sticky: false, key: "toast-messages"});
    }

    /**
     * Shows message
     */
    public toastInfoSticky(aMessage: string, aLife?: number) {
        this.messageService.clear();
        this.messageService.add({severity: 'info', detail: aMessage, life: aLife ? aLife : 1500, closable: true, sticky: true, key: "toast-messages"});
    }

    public toastWarnSticky(aMessage: string) {
        this.messageService.clear();
        this.messageService.add({severity: 'warn', detail: aMessage, life: 1500, closable: true, sticky: true, key: "toast-messages"});
    }

    /**
     * Shows message
     */
    public toastOperationComplete() {
        this.toastInfo(this.v("operationComplete"));
    }

    public showErrorDialog(aMessage: string) {
        this.messageService.add({severity: 'error', summary: this.i18n.v('error'), detail: aMessage, data: 'open_in_dialog'});
    }

    /**
     * Marks all controls als "dirty" to showup empty "required" fields".
     */
    public markFormDirty(aForm: NgForm) {
        Object.keys(aForm.controls).forEach(key => {
            //-- this.logi("[" + key + "] " + aForm.form.controls[key]);
            aForm.form.controls[key].markAsDirty();
        });
    }

    /*
     * Handler.
     */
    protected onRestViolation(aResponseXBVO: ResponseXBVO) {
        if (aResponseXBVO.error === "E_NOT_FOUND") {
            this.messages = this.v("invalid_objectnr") + "!";
        } else {
            this.messages = "[Fehler] " + aResponseXBVO.errorDescription;
        }
    }

    public isMobile(): boolean {
        let pMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        return pMobile;
    }

    goToUrl(aUrl: string): void {
        window.location.href = aUrl;
    }

    /**Checks for production  */
    public isProductionMode(): boolean {
        return environment.production;
    }

    /**
     * Formats.
     * @param aNumber
     */
    public formatTwoDecimal(aNumber: number) {
        return NumberUtils.formatTwoDecimal(aNumber);
    }

    /**
     * Handler.
     * @param $event
     */
    public handleMissingImage(aEvent: ErrorEvent, aFallbackImage?: string) {
        this.logi("Missing image: " + aEvent);
        if (!aFallbackImage) {
            aFallbackImage = 'assets/icons/meal.svg';
        }
        (aEvent.target as HTMLImageElement).src = aFallbackImage;
    }

    /**
     * Formats.
     * @param aDate
     * @param aPattern
     */
    public dateFormat(aDate: Date, aPattern?: string) {
        if (aDate == null) {
            return null;
        }
        return aPattern ? DateUtilsBs.format(aDate, aPattern) : DateUtilsBs.formatDate(aDate);
    }

    public isYesterday(aDate: Date): boolean {
        return DateUtilsBs.isYesterday(aDate);
    }

    public isToday(aDate: Date): boolean {
        return DateUtilsBs.isToday(aDate);
    }

    /**
     * Downloads.
     * @param aBlob
     * @param aLink
     */
    public fileDownload(aBlob: Blob, aFileName: string) {
        saveAs(aBlob, aFileName);
    }

    /**
     * Full reload.
     */
    public reloadPage() {
        window.location.reload();
    }


    /**
     * Full reload.
     */
    public redirectTo(aRouter: Router, aPath: string) {
        aRouter.routeReuseStrategy.shouldReuseRoute = () => false;
        aRouter.onSameUrlNavigation = 'reload';
        aRouter.navigate(['/orders']);
    }

    /**
     * Today.
     */
    public getToday(): Date {
        return this.today;
    }

    /**
     * Yesterday.
     */
    public getYesterday(): Date {
        return this.yesterday;
    }

    /**
     * Normalizes null-values
     * @param aNumber
     */
    public normalizeZero(aNumber: number) : number {
        return NumberUtils.normalizeZero(aNumber);
    }
}
